module.exports = __webpack_public_path__ + "static/media/shopping-cart-duotone.2fe44cb5.svg";